import * as React from 'react';
import { TableFetchParams, tableQueryMaker } from '@core/table';
import { useService } from '@core/inversify-react';

import { GetBranchesRepoType, IGetBranchesRepo } from '../../repos';

export const useBranchesTableContext = () => {
  const getBranchesRepo = useService<IGetBranchesRepo>(GetBranchesRepoType);

  const onFetch = React.useCallback(
    async (params: TableFetchParams) => {
      const result = await getBranchesRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getBranchesRepo],
  );

  return { onFetch };
};
